/** Host del frontend QA donde se habilitan logs de depuración en consola. */
export const QA_FRONTEND_HOST = 'chikara-frontend.qa-albo.tech';

declare const __CHIKARA_APP_VERSION__: string;

export const APP_VERSION =
  typeof __CHIKARA_APP_VERSION__ !== 'undefined'
    ? __CHIKARA_APP_VERSION__
    : (import.meta.env.VITE_APP_VERSION ?? '0.0.0');

export function isQaFrontendHost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === QA_FRONTEND_HOST;
}
